export default __webpack_public_path__ + "static/media/courses-new.e2953dec.svg";